import uuidV4 from 'uuid/v4';

export const codAdditionalServiceID = 'CashOnDelivery';

export const deliveryIDPrefixes = {
  Default: 'EX',
  BulkUpload: 'BK',
};

export const genDeliveryID = (prefix = deliveryIDPrefixes.Default) => {
  return `${prefix}-${uuidV4()}`;
};

export const isBulkUploadDeliveryID = deliveryID =>
  deliveryID && deliveryID.startsWith(deliveryIDPrefixes.BulkUpload);

// ref: express/grab-express/dto/geerrors/geerrors_pax.go:121
export const ErrorCodes = {
  OutOfWindow: {
    code: 1014,
  },
  RedirectToPaymentSDK: {
    code: 1094,
  },
  DuplicatedBooking: {
    code: 1072,
  },
};

export const TIME_12H = 'h:mm a';

export const TIME_24H = 'HH:mm';

export const DEFAULT_TIME_FORMAT = TIME_12H;

export const OFFER_MAX_EXPIRED_DAY_DISPLAY_COUNT = 3;

export const TIME_FORMAT = {
  VN: TIME_24H,
  TH: TIME_24H,
  ID: TIME_24H,
  SG: TIME_12H,
  MY: TIME_12H,
  PH: TIME_12H,
};

export default {};
